import { render, staticRenderFns } from "./VsmHistoryLinkButton.vue?vue&type=template&id=c3300b24&"
import script from "./VsmHistoryLinkButton.vue?vue&type=script&lang=js&"
export * from "./VsmHistoryLinkButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports